import React, { useState } from 'react';
import { Routes, Route, Link, useLocation, Navigate } from 'react-router-dom';
import Landing from './pages/Landing';
import Onboarding from './pages/Onboarding';
import Upload from './pages/Upload';
import Contacts from './pages/Contacts';
import Upcoming from './pages/Upcoming';
import MessagingOptIn from './pages/MessagingOptIn';
import Login from './pages/Login';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Admin from './pages/Admin';
import Upgrade from './pages/Upgrade';
import Unsubscribe from './pages/Unsubscribe';
import MothersDay from './pages/MothersDay';
import './App.css';

function App() {
  const [userId, setUserId] = useState(localStorage.getItem('string_user_id'));
  const location = useLocation();
  const isLanding = location.pathname === '/';
  const isDemo = location.pathname === '/demo';
  const standalonePaths = ['/messaging_opt_in', '/privacy', '/terms', '/admin', '/unsubscribe', '/mothers-day'];
  const isStandalone = standalonePaths.includes(location.pathname);
  const isUpgrade = location.pathname === '/upgrade';
  const showAppChrome = !isLanding && !isDemo && !isStandalone;

  return (
    <div className={(isLanding || isStandalone) ? '' : 'app'}>
      {showAppChrome && (
        <header>
          <Link to="/" className="logo">String</Link>
          <p className="tagline">Stay on top of what's important.</p>
          {userId ? (
            <nav>
              <Link to="/onboarding">Import</Link>
              <Link to="/account">Contacts</Link>
              <Link to="/upcoming">Upcoming</Link>
              <Link to="/upgrade" style={{ color: '#5D4037', fontWeight: '600' }}>Premium</Link>
              <span style={{ cursor: 'pointer', color: '#888', fontSize: '0.85rem' }} onClick={() => { localStorage.removeItem('string_user_id'); setUserId(null); }}>Sign out</span>
            </nav>
          ) : (
            <nav>
              <Link to="/login">Log In</Link>
              <Link to="/messaging_opt_in">Sign Up</Link>
            </nav>
          )}
        </header>
      )}
      <main>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/signup" element={<Navigate to="/messaging_opt_in" replace />} />
          <Route path="/onboarding" element={<Onboarding userId={userId} />} />
          <Route path="/demo" element={<Onboarding demo={true} />} />
          <Route path="/upload" element={<Upload userId={userId} />} />
          <Route path="/account" element={<Contacts userId={userId} />} />
          <Route path="/contacts" element={<Navigate to="/account" replace />} />
          <Route path="/upcoming" element={<Upcoming userId={userId} />} />
          <Route path="/login" element={<Login setUserId={setUserId} />} />
          <Route path="/messaging_opt_in" element={<MessagingOptIn setUserId={setUserId} />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/admin" element={<Admin userId={userId} />} />
          <Route path="/upgrade" element={<Upgrade userId={userId} />} />
          <Route path="/unsubscribe" element={<Unsubscribe />} />
          <Route path="/mothers-day" element={<MothersDay userId={userId} />} />
        </Routes>
      </main>
    </div>
  );
}

export default App;
